export default __webpack_public_path__ + "static/media/adidas-sponsor.1c740a7e.png";